import { isOutsourcing } from 'js/utils/emailOutsourcingUtils';

import { PrivilegedAuthsV1NaptimeResource } from './__generated__/PrivilegedAuthsV1';

class PrivilegedAuths extends PrivilegedAuthsV1NaptimeResource {
  static RESOURCE_NAME = 'privilegedAuths.v1' as const;

  static me(opts: { fields: string[] }) {
    return this.finder('me', opts, (profiles) => profiles[0]);
  }

  static getIsOutsourcingAgent(user: { get: () => { email_address: string } }) {
    // check the hacky isOutsourcing util first to avoid making an extra api call for most users
    if (isOutsourcing(user)) {
      return this.finder(
        'me',
        {
          fields: ['outsourcingPermissions'],
        },
        (profiles) => !!profiles[0] && !!profiles[0].outsourcingPermissions
      );
    } else {
      return false;
    }
  }
}

export default PrivilegedAuths;
